import { baseUrlApis } from "@/api";
import { GOOGLE_DRIVE_ACCESS_TOKEN } from "@/constants/local.constant";
import { enUS } from "@/locales";
import { isDTRuntime } from "@/modules/3rd-party-integration/utils/env";
import { lazyLoadDingtalk } from "@/modules/dingtalk/lazy-load";
import store from "@/store";
import { userService } from "@/store/services";
import { getQueryVariable, isFromFoxitWebsite, prop, storageGetItem, storageSetItem } from "./utils";

const intlMessages = {
    // zh: zhCN,
    en: enUS,
    // ja: jaJP,
    // it: itIT,
    // ko: koKR,
    // de: deDE,
    // fr: frFR,
    // es: es419,
    // nl: nlNL,
};

// 判断用户token过期时自动登录
async function checkAutoLoginFlow() {
    try {
        const cookieToken = await store.userStore.getToken();
        const storageToken = storageGetItem(window.localStorage, 'driver_access_token_for_auto_login');

        if (!cookieToken && !storageToken) {
            const fromFoxitWebsite = isFromFoxitWebsite()

            if (fromFoxitWebsite) {
                store.userStore.initProcessNeedLogin('/');
                store.userStore.updateSignUpPopupSrcType('autoLogin');
            }

            return
        }

        userService.updateHideNotifyErrors(true);

        // const token = cookieToken || storageToken;
        // const res = await userService.getUserInfo(token);

        // if (res && res.ret === 210007 && res.info && res.info.message === 'TOKEN_ERROR') {
        //     // eslint-disable-next-line require-atomic-updates
        //     store.userStore.updateIsTokenExpired(true);
        //     store.userStore.initProcessNeedLogin('/', true);
        //     store.userStore.updateSignUpPopupSrcType('autoLogin');
        // } else {
        //     userService.resetHideNotifyErrors();
        // }
    } catch (error) {
        userService.resetHideNotifyErrors();
        console.error(error);
    }
}

function isRedirectToGoogleOAuth() {
    const action = getQueryVariable('action');
    const fileParams = getQueryVariable('state');
    const googleOAuthCode = getQueryVariable('googleOAuthCode');
    const googleDriveAccessToken = getQueryVariable('GoogleDriveAccessToken');
    const googleDriveAccessTokenFromLocal = storageGetItem(localStorage, GOOGLE_DRIVE_ACCESS_TOKEN);

    if (fileParams && !googleOAuthCode && !googleDriveAccessToken && !googleDriveAccessTokenFromLocal) {
        store.driveStore.redirectToGoogleOAuth(fileParams);
    } else if (action === 'gdriveSetupInstruction') {
        //?action=gdriveSetupInstruction
        store.driveStore.redirectToGoogleOAuth(action);
    } else if (googleDriveAccessToken && !googleDriveAccessTokenFromLocal) {
        storageSetItem(localStorage, 'GoogleDriveAccessToken', googleDriveAccessToken);
    }
}

function init() {
    const { userInfo } = store.userStore;

    // 未登录用户直接跳转Google Auth认证
    if (!userInfo) {
        isRedirectToGoogleOAuth();

        return;
    }

    // 登陆用户账号和区相同则跳转Google Auth认证
    if (store.userStore.isInSameEnv()) {
        isRedirectToGoogleOAuth();

        return;
    }
}

export default async function beforeRenderApp() {
    const { lang, full } = store.appStore.lng;
    await store.appStore.loadLocales({ lang, full }, intlMessages);
    let pathname = prop(location, 'pathname');
    // const cfg = await baseUrlApis.loadUrlConfig();
    // store.appStore.initGlobalConfig(cfg);
    store.appStore.updateLoading(false);

    // if (isDTRuntime) {
    //     // Load Dingtalk Module
    //     const { initialize } = await lazyLoadDingtalk();
    //     await initialize(pathname);
    // } else {
    //     await checkAutoLoginFlow();
    //     await store.userStore.initializeOnFirst(pathname);
    //     init();
    // }
    window.onlineGlobals = {
        showAllTooltip: true
    }
}
